import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
export var CapacityOptions;
(function (CapacityOptions) {
    CapacityOptions[CapacityOptions["InCapacity"] = 1] = "InCapacity";
    CapacityOptions[CapacityOptions["Overcap"] = 0] = "Overcap";
})(CapacityOptions || (CapacityOptions = {}));
export const CapacityOptionsMap = new Map([
    [CapacityOptions.InCapacity, 'Global.Text.InCapacity'],
    [CapacityOptions.Overcap, 'Global.Text.Overcap'],
]);
let CapacityService = class CapacityService {
    constructor(_translate) {
        this._translate = _translate;
        this._data = CapacityOptionsMap;
    }
    list() {
        return this._data;
    }
    get(key) {
        const k = this._data.get(key);
        return k ? this._translate.instant(k) : k;
    }
};
CapacityService.ctorParameters = () => [
    { type: TranslateService }
];
CapacityService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [TranslateService])
], CapacityService);
export { CapacityService };
